<script setup>
import List from './components/ViewList'
import FilterBar from './components/FilterBar.vue'
import SelectedFilters from "@/components/SelectedFilters.vue";
import {ref, onMounted, onBeforeUnmount, watch} from 'vue'
import {useFilterStore} from '@/store/filter'
import {useProductListStore} from '@/store'

const filterStore = useFilterStore()
const productStore = useProductListStore()
const bp = ref(0)

function getBreakpoint() {
  try {
    const content = window.getComputedStyle(document.body, ':after').getPropertyValue('content')
    const raw = String(content).replace(/['"]/g, '')
    const n = parseInt(raw.split('-')[1], 10)
    return Number.isFinite(n) ? n : 0
  } catch (_) {
    return 0
  }
}

let rafId = null
let stopSelectedWatcher

function onResize() {
  if (rafId) return
  rafId = requestAnimationFrame(() => {
    rafId = null
    bp.value = getBreakpoint()
  })
}

onMounted(async () => {
  window.productStore = productStore
  window.filterStore = filterStore
  bp.value = getBreakpoint()
  window.addEventListener('resize', onResize, {passive: true})

  if ((productStore.hideSideBar !== '1' && productStore.tpgSideBarNavigation !== '1')) {
    await filterStore.initFiltersFromUrlOnce()
    filterStore.startUrlSync?.()

    stopSelectedWatcher = watch(
      () => filterStore.selected,
      () => filterStore._onSelectedChanged && filterStore._onSelectedChanged(),
      { deep: true }
    )
  } else {
    // Important: without this, filterStore.loaded stays false forever
    filterStore.setLoaded(true)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)

  if ((productStore.hideSideBar !== '1' && productStore.tpgSideBarNavigation !== '1') && stopSelectedWatcher) {
    stopSelectedWatcher()
  }

  if ((productStore.hideSideBar !== '1' && productStore.tpgSideBarNavigation !== '1')) {
    filterStore.stopUrlSync?.()
  }
})
</script>

<template>
  <div id="product-list" class="col-wrapper -max-width-limited" :class="(productStore.hideSideBar === '1' || productStore.tpgSideBarNavigation === '1') ? 'l-1col' : 'l-2col l-2col-b2-33-66 l-2col-b3-25-75'">
    <FilterBar v-if="!(productStore.hideSideBar === '1') && !(productStore.tpgSideBarNavigation === '1')"/>
    <div class="product-list--list col col-two" :class="(productStore.hideSideBar === '1' || productStore.tpgSideBarNavigation === '1') ? 'col-one' : 'col-two'">
      <SelectedFilters v-if="bp >= 2 && !(productStore.hideSideBar === '1') && !(productStore.tpgSideBarNavigation === '1')"/>
      <List/>
    </div>
  </div>
</template>
